import * as React from "react"
import { Link } from "gatsby"

const Breadcrumbs = ({ title, pageParentTitle, pageParentPath }) => {
  return (
    <div className={"relative"}>
      <div className={"bg-blue text-xs py-2"}>
        <div className={"max-w-6xl mx-auto"}>
          <ul
            className={
              "flex flex-col md:flex-row items-center justify-center md:gap-2 font-bold text-navy uppercase tracking-wider"
            }
          >
            <li className={"text-xs"}>
              <Link
                to={"/"}
                className={
                  "hover:text-blue-700 transition duration-500 ease-in-out"
                }
              >
                Home
              </Link>
            </li>

            {pageParentTitle && (
              <li className={"text-xs"}>
                <span className={"text-blue-700 mr-2"}>/</span>
                <Link
                  to={pageParentPath}
                  className={
                    "hover:text-blue-700 transition duration-500 ease-in-out"
                  }
                >
                  {pageParentTitle}
                </Link>
              </li>
            )}

            <li className={"font-normal text-xs"}>
              <span className={"text-blue-700 mr-2"}>/</span>
              {title}
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Breadcrumbs
